/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Minimal discovery surface for requesting bookings, without workspace data.
 * @export
 * @interface BookingStage
 */
export interface BookingStage {
    /**
     *
     * @type {string}
     * @memberof BookingStage
     */
    readonly id: string;
    /**
     *
     * @type {string}
     * @memberof BookingStage
     */
    readonly name: string;
    /**
     *
     * @type {string}
     * @memberof BookingStage
     */
    readonly venue: string;
    /**
     *
     * @type {string}
     * @memberof BookingStage
     */
    readonly venueName: string;
    /**
     * Maximum audience capacity
     * @type {number}
     * @memberof BookingStage
     */
    readonly capacity: number | null;
    /**
     *
     * @type {number}
     * @memberof BookingStage
     */
    readonly hostTeam: number;
}

/**
 * Check if a given object implements the BookingStage interface.
 */
export function instanceOfBookingStage(value: object): value is BookingStage {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('venue' in value) || value['venue'] === undefined) return false;
    if (!('venueName' in value) || value['venueName'] === undefined) return false;
    if (!('capacity' in value) || value['capacity'] === undefined) return false;
    if (!('hostTeam' in value) || value['hostTeam'] === undefined) return false;
    return true;
}

export function BookingStageFromJSON(json: any): BookingStage {
    return BookingStageFromJSONTyped(json, false);
}

export function BookingStageFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookingStage {
    if (json == null) {
        return json;
    }
    return {

        'id': json['id'],
        'name': json['name'],
        'venue': json['venue'],
        'venueName': json['venue_name'],
        'capacity': json['capacity'],
        'hostTeam': json['host_team'],
    };
}

  export function BookingStageToJSON(json: any): BookingStage {
      return BookingStageToJSONTyped(json, false);
  }

  export function BookingStageToJSONTyped(value?: Omit<BookingStage, 'id'|'name'|'venue'|'venue_name'|'capacity'|'host_team'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

    };
}
